import React, { Component } from 'react'
import './style.css'
import Grid from './grid3'
import {Button} from '@material-ui/core'

import {data_event} from '../../dummy/data_event'
import moment from 'moment'
import {connect} from 'react-redux'
import {getEvent} from '../../redux/action/event'
import Skeleton from 'react-loading-skeleton'
class event extends Component {
    state={
        webinar:[],
        event:[]
    }
    componentDidMount(){
        this.props.getEvent()
    }

    componentWillReceiveProps(newProps){
        const {list_event}=newProps.event
        let webinar=[],event=[]
        if(list_event!==null){
            list_event.map((data,i)=>{
                // if(data.webEvent.categoryId===1||data.webEvent.categoryId===2){
                //     event.push(data)
                // }else{
                //     // console.log('test', data)
                //     webinar.push(data)
                // }
                webinar.push(data)

            })
            this.setState({webinar})
        }
    }
    loader=()=>{
        return(
            <div className='loader-skeleton'>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
                <Skeleton height={200}/>
            </div>
        )
    }
    render() {
        let {webinar}=this.state
        let {jumlah,general}=this.props
        let webinar_3=[]
        webinar.map((data,i)=>{
            if(i<jumlah){
                webinar_3.push(data)
            }
        })
        // let a=data_event.filter((data)=>{
        //     return data.type==='Webinar'
        // })
        // let open=[]
        // if(a.length>0){
        //     a.map((datawebinar,i)=>{
        //         console.log('datawebinar', datawebinar)
        //         let date=moment(datawebinar.end_date).format('YYYY-MM-DD')
        //         let now=moment().format('YYYY-MM-DD')
        //         let is_open=moment(date).isSameOrAfter(now)
        //         if(is_open){
        //            open.push(datawebinar)
        //         }
        //     })
        // }
        // if(open.length>0){
        //     open.map((webinar_open,i)=>{
        //         if(i<jumlah){
        //             webinar.push(webinar_open)
        //         }
        //     })
        // }
        return (
            <div>
                {webinar_3.length>0&&
                 <div className='head'>
                    <div style={{display:'flex',alignItems:'center',justifyContent:'flex-start'}}>                        
                    <h2>Event & Webinar </h2>
                    &nbsp;&nbsp;&nbsp;
                    <div className='event-header-joinwithus hidden-mobile' style={{width:1,height:40,backgroundColor:'grey'}}></div>
                    &nbsp;&nbsp;&nbsp;
                    <p className='event-header-joinwithus hidden-mobile'>Join with us</p>
                    </div>
                    <div>
                        <Button style={{textTransform:'none',fontWeight:'bold',zIndex:1}} color="primary" onClick={()=>window.location.assign('/event')}>More event </Button>
                    </div>
                </div>
                }
                <br/>
                {general.isLoading?this.loader():<Grid data={webinar_3} link="/event/detail" />}
            </div>
        )
    }
}
const mapStateToProps=(state)=>({
    general:state.general,
    event:state.event
})
const mapDispatchToProps={
    getEvent
}
export default connect(mapStateToProps,mapDispatchToProps)(event)